
<el-select
  v-model="country"
  class="phone-initial-country"
  filterable
  clearable
  :placeholder="
    $t('element.property.form.field.phone.initial_country.placeholder')
  "
  @change="onCountryChange"
>
  <el-option
    v-for="item in countries"
    :key="item.alpha2"
    :label="item.name"
    :value="item.alpha2.toLowerCase()"
  />
</el-select>
